import React, { useState } from 'react';
import { Container, Row, Col, Collapse, Button } from 'react-bootstrap';
import { map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { routePersonalAccidentQuoteComparePage } from '@components/PersonalAccidentQuoteComparePage';

import { compareRemoveAll } from '../action';
import { selectPersonalAccidentQuoteResultPage } from '../selector';
import { usePersonalAccidentQuoteResultPageParams } from '../hook';
import { PersonalAccidentQuoteItem } from './personal-accident-quote-item';
import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';

const ComparablePersonalAccidentQuote = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = usePersonalAccidentQuoteResultPageParams();
  const { comparablePersonalAccidentQuotes: personalAccidentQuotes } = useSelector(
    selectPersonalAccidentQuoteResultPage,
  );
  const [open, setOpen] = useState(false);
  const hasPersonalAccidentQuotes = personalAccidentQuotes.length > 0;

  const handleRemoveAll = () => {
    dispatch(compareRemoveAll());
  };

  const handleCompare = () => {
    navigate(
      routePersonalAccidentQuoteComparePage({
        ...params,
        personalAccidentPlanIds: map(personalAccidentQuotes, 'personalAccidentPlanId'),
      }),
    );
  };

  if (!hasPersonalAccidentQuotes) return null;

  return (
    <div className="p-3 w-100 fixed-bottom shadow-lg bg-white" data-testid="comparable-personal-accident-quote">
      <Container>
        <h6 className="m-0 text-center c-pointer" onClick={() => setOpen(!open)}>
          <span className="me-2">
            {t('common:compareQuotes')} ({personalAccidentQuotes.length})
          </span>
          <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
        </h6>
        <Collapse in={open}>
          <Row className="mt-3">
            {map(personalAccidentQuotes, (quote: PersonalAccidentQuote) => (
              <Col className="d-flex align-items-center border-end" key={quote.personalAccidentPlanId}>
                <PersonalAccidentQuoteItem {...quote} />
              </Col>
            ))}

            {personalAccidentQuotes.length === 1 && (
              <Col>
                <div className="d-flex flex-column justify-content-center align-items-center h-100 border-end">
                  <span className="text-danger">{t('common:compareGuide', { max: 2 })}</span>
                </div>
              </Col>
            )}

            <Col lg={2}>
              <div className="d-flex flex-column">
                <Button className="mb-3" onClick={handleCompare}>
                  {t('common:compare')}
                </Button>
                <Button variant="light" onClick={handleRemoveAll}>
                  {t('common:removeAll')}
                </Button>
              </div>
            </Col>
          </Row>
        </Collapse>
      </Container>
    </div>
  );
};

export { ComparablePersonalAccidentQuote };
